import React from 'react'
import { GuildShieldSolid } from '@/atoms/Icons/GuildShieldSolid'
import { ParagraphSM, TitleXS } from '@/atoms/Text'
import { CaptionMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { BaseTooltipProps } from '.'
import { BaseTooltip } from '.'

export const GuildScoreToolTip: React.FC<BaseTooltipProps> = ({
  iconSize = 16,
  className,
  buttonClassName,
  panelClassName,
  panelPosition = 'CENTER',
  isIconOnly,
  removeBorder = false,
  buttonStyle,
  iconColor = 'core-gray-300',
  guildScore,
}) => {
  const { t } = useTranslate('tickets')

  const trigger = (
    <>
      <div>
        <GuildShieldSolid size={iconSize} color={iconColor} />
      </div>

      <CaptionMD>{guildScore}</CaptionMD>
    </>
  )

  const content = (
    <>
      <TitleXS color="core-gray-950" weight="bold">
        {t('whatIsGuildScore', 'What is the Guild Score?')}
      </TitleXS>
      <ParagraphSM className="mt-2 text-[0.688rem] leading-[16px]" color="core-gray-700">
        {t(
          'guildScoreDescriptionPassionAngel',
          'The higher the Guild score, the more passionate Angel members are about this film or series coming to Angel.',
        )}
      </ParagraphSM>
    </>
  )

  return (
    <BaseTooltip
      className={className}
      buttonClassName={buttonClassName}
      panelClassName={panelClassName}
      panelPosition={panelPosition}
      isIconOnly={isIconOnly}
      removeBorder={removeBorder}
      buttonStyle={buttonStyle}
      trigger={trigger}
      content={content}
    />
  )
}
